"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var timezones_1 = require("../data/timezones");
var getTimeZone = function (name) {
    return timezones_1.TimezoneData.find(function (timezone) { return timezone.name === name; });
};
var timeInCurrentZone = function (day, hour, minute, timezone, timezoneOffset) {
    var offset = timezoneOffset || getTimeZone(timezone).offset;
    var curr = new Date();
    var date = new Date(curr.getFullYear(), curr.getMonth(), curr.getDate());
    var dayToAdd = ((day - date.getDay()) + 7) % 7;
    var minutesToAdd = 0
        + dayToAdd * 24 * 60
        + hour * 60
        + minute
        - (date.getTimezoneOffset() + offset);
    date.setTime(date.getTime() + minutesToAdd * 60 * 1000);
    return date;
};
var hourString = function (hours, minutes) {
    return [
        ("0" + hours.toString()).slice(-2),
        ("0" + minutes.toString()).slice(-2)
    ].join(":");
};
var offsetToHourString = function (offset) {
    var hoursWithSign = Math.trunc(offset / 60);
    var hours = Math.abs(hoursWithSign);
    var negative = hoursWithSign < 0;
    var minutes = offset % 60;
    return [
        negative ? "-" : "+",
        hourString(hours, minutes),
    ].join("");
};
var detect = function () {
    var offset = -(new Date()).getTimezoneOffset();
    return timezones_1.TimezoneData.find(function (timezone) { return timezone.offset === offset; });
};
exports.detect = detect;
var getSelectOptions = function () {
    timezones_1.TimezoneData.map(function (timezone) { return ({
        label: "(GMT" + offsetToHourString(timezone.offset) + ") " + timezone.name,
        value: timezone.name,
    }); });
};
exports.getSelectOptions = getSelectOptions;
var scheduleToCurrentDates = function (schedule, timezone, timezoneOffset) {
    var days = [[], [], [], [], [], [], []];
    schedule
        .filter(function (s) { return s.from || s.to; })
        .forEach(function (s) {
        if (s.from || s.to) {
            var _a = (s.from || "00:00").split(":").map(function (e) { return parseInt(e, 10); }), fHour = _a[0], fMin = _a[1];
            var _b = (s.to || "24:00").split(":").map(function (e) { return parseInt(e, 10); }), tHour = _b[0], tMin = _b[1];
            var from = timeInCurrentZone(s.day, fHour, fMin, timezone, timezoneOffset);
            var to = timeInCurrentZone(s.day, tHour, tMin, timezone, timezoneOffset);
            if (from.getDay() === to.getDay()) {
                days[from.getDay()].push({
                    from: from,
                    to: to,
                });
            }
            else {
                var newTo = new Date(from.getFullYear(), from.getMonth(), from.getDate(), 24, 0);
                var newFrom = new Date(to.getFullYear(), to.getMonth(), to.getDate(), 0, 0);
                if (from.getTime() !== newTo.getTime()) {
                    days[from.getDay()].push({
                        from: from,
                        to: newTo,
                    });
                }
                if (newFrom.getTime() !== to.getTime()) {
                    days[to.getDay()].push({
                        from: newFrom,
                        to: to,
                    });
                }
            }
        }
    });
    return days.map(function (day) { return day.sort(function (a, b) { return a.from - b.from; }); });
};
exports.scheduleToCurrentDates = scheduleToCurrentDates;
//# sourceMappingURL=timezone.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/timezone.js
// module id = 876
// module chunks = 3